import React, { useEffect, useMemo } from "react";
import { useAppSelector } from "../../../Store";
import { UndefinedOptions } from "..";
import { Graph_QL } from "../../../Services";
import { SelectFieldOption_Values } from "../../../Definitions";
import { useAnimalGroups } from "../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimalGroups";

export const useGroupOptions = (includeUndefinedOption?: UndefinedOptions) => {
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getAnimalGroups, data: animalGroupsState } = useAnimalGroups(connection);

  useEffect(() => {
    getAnimalGroups({fetchAmount: 500, ifIncludeAnimalCount: true})
  }, []);

  const groupOptions: SelectFieldOption_Values[] = useMemo(() => {
    if (animalGroupsState && animalGroupsState[domain]) {
      const groups = animalGroupsState[domain].data.map(group => ({
        label: group.name,
        id: group.animal_group_id,
      }));


      if (includeUndefinedOption === UndefinedOptions.undefined) {
        return [{ label: "no group", id: null }, ...groups];
      } else if (includeUndefinedOption === UndefinedOptions.nan) {
        return [{ label: "no group", id: NaN }, ...groups];
      }

      return groups;
    }
    return includeUndefinedOption === UndefinedOptions.undefined ? [{ label: "No group", id: null }] : includeUndefinedOption === UndefinedOptions.nan ? [{ label: "No group", id: NaN }] : [];
  }, [domain, animalGroupsState, includeUndefinedOption]);

  return groupOptions;
};
